<template>
  <div>
    <div class="component-container">
      <div class="container-head contain-btn-title">
        <div class="container-head-title">
          <el-form label-width="80px">
            <div class="member-form-wrapper">
              <el-form-item
                label="用户名:"
                size="small"
                style="font-weight: 500"
              >
                <el-input
                  v-model="form.name"
                  placeholder="请输入"
                  @keyup.enter.native="handleQueryClick"
                  :clearable="true"
                />
              </el-form-item>
              <el-form-item
                label="手机号:"
                size="small"
                style="font-weight: 500"
              >
                <el-input
                  v-model="form.phone"
                  placeholder="请输入"
                  @keyup.enter.native="handleQueryClick"
                  :clearable="true"
                />
              </el-form-item>

              <span class="member-head-opt-btn">
                <common-button
                  type="primary"
                  size="default"
                  image
                  @click="handleQueryClick"
                  >查询</common-button
                >
                <common-button
                  type="cancel"
                  size="default"
                  image
                  @click="resetConditions"
                  >重置</common-button
                >
              </span>
            </div>
          </el-form>
        </div>
      </div>
      <div class="container-body">
        <div class="member-approve-table">
          <el-table
            :header-cell-style="{
              background: '#E5F5F9',
              fontSize: '16px',
              color: '#353739'
            }"
            :stripe="true"
            row-class-name="vertical-align-top"
            size="small"
            v-loading="data.isLoading"
            :data="data.list"
            style="width: 100%;margin-top: 10px;"
            fit
          >
            <el-table-column
              sortable
              align="center"
              prop="name"
              label="用户名"
            ></el-table-column>
            <el-table-column
              sortable
              align="center"
              prop="userId"
              label="手机号"
            ></el-table-column>
            <el-table-column
              sortable
              align="center"
              prop="majorDepartName"
              label="注册机构"
            ></el-table-column>
            <el-table-column
              sortable
              align="center"
              prop="isApprv"
              label="审核状态"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.isApprv == 0">待审核</span>
                <span v-else-if="scope.row.isApprv == 2">已拒绝</span>
              </template>
            </el-table-column>
            <el-table-column
              sortable
              align="center"
              prop="rejectReason"
              label="拒绝原因"
            ></el-table-column>
            <el-table-column
              sortable
              align="center"
              prop="lastUpdateInfoTime"
              label="最后修改时间"
            >
              <template slot-scope="scope">{{
                scope.row.lastUpdateInfoTime | datetimeFormat
              }}</template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="150">
              <template slot-scope="scope">
                <button
                  class="eims-button eims-button--text"
                  @click="handleViewClick(scope.row)"
                >
                  查看
                </button>
                <button
                  class="eims-button eims-button--text"
                  @click="toEditedDialog(scope.row)"
                >
                  审核
                </button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-container">
            <el-pagination
              style="float: right; padding: 3px 0"
              layout="sizes, prev, pager, next"
              :page-size="data.pageSize"
              :total="data.total"
              :page-sizes="data.pageSizeArray"
              @current-change="handlePageChange"
              @size-change="handleSizeChange"
              :current-page="data.currentPage"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="edited.editedDialogFlag"
      @close="handleCloseDialog"
      min-width="430px"
      width="430px"
    >
      <div class="dialog-title" slot="title">
        审核
      </div>
      <el-form label-width="110px" size="small">
        <el-form-item label="用户名:">
          <span class="dialog-content-span">{{ edited.name }}</span>
        </el-form-item>
        <el-form-item label="注册机构:">
          <span class="dialog-content-span">{{ edited.majorDepartName }}</span>
        </el-form-item>
        <el-form-item label="是否同意:">
          <span class="dialog-content-span">
            <el-radio v-model="edited.isApprv" label="1">同意</el-radio>
            <el-radio v-model="edited.isApprv" label="0">拒绝</el-radio>
          </span>
        </el-form-item>
        <el-form-item
          size="small"
          style="font-weight: 500;text-align: center;"
          v-if="edited.isApprv == '1'"
        >
          <template slot="label">
            <span class="required-label">*</span>
            <span>关联机构:</span>
          </template>
          <el-cascader
            ref="editDeptCascader"
            :props="{ checkStrictly: true }"
            :options="form.departments"
            @change="handleApproveDeptChange"
            :show-all-levels="false"
            clearable
            filterable
            style=""
          >
          </el-cascader>
          <a
            @click="handleAddDept"
            style="cursor: pointer;text-decoration:underline"
            >新增机构</a
          >
        </el-form-item>
        <el-form-item label="拒绝原因:" v-if="edited.isApprv == '0'">
          <el-input type="textarea" v-model="edited.rejectReason"></el-input>
        </el-form-item>
      </el-form>
      <template slot="footer" class="button-footer" style="">
        <common-button
          @click="handleCommitDialog"
          size="small"
          type="primary"
          style="text-align: center"
          >提交</common-button
        >
        <common-button
          @click="handleCloseDialog"
          size="small"
          type="cancel"
          style="text-align: center"
          >取消</common-button
        >
      </template>
    </el-dialog>

    <el-dialog
      class="view-dialog"
      :visible.sync="view.viewDialogFlag"
      @close="handleCloseDialog"
    >
      <div style="height: 600px;overflow-y: auto">
        <MyInfo
          :userId="view.userId"
          :showDirected="false"
          :showEmptyInfo="false"
          v-if="view.viewDialogFlag"
        ></MyInfo>
      </div>
    </el-dialog>

    <el-dialog
      class="add-dept-dialog"
      :close-on-click-modal="false"
      :visible.sync="addDepartment.addDialogFlag"
      @close="handleCloseAddDeptDialog"
    >
      <!--      <div style="height: 600px;overflow-y: auto">-->
      <Create :componentFlag="true" v-if="addDepartment.addDialogFlag"></Create>
      <!--      </div>-->
    </el-dialog>

    <!--动画加载组件-->
    <animation
      :loadingDataVisible="loadingDataVisible"
      :loadingText="'Loading'"
    ></animation>
  </div>
</template>

<script>
import http from "@/utils/axios";
import { mapState } from "vuex";
import cookie from "@/utils/cookie";
import { Message } from "element-ui";
import animation from "@/components/loading/animation";
import MyInfo from "@/pages/user/MyInfo";
import Create from "@/pages/dept/Create";
import { PAGE_SIZE_ARRAY } from "@/constants/constants";

export default {
  name: "MemberApprove",
  components: {
    animation,
    MyInfo,
    Create
  },
  data() {
    return {
      loadingDataVisible: false,
      this_: this,
      form: {
        phone: "",
        name: "",
        departmentId: null,
        provinceCode: "",
        cityCode: "",
        pCodeAndCCode: [],
        departments: [],
        codesTree: [],
        eimsCodes: []
      },
      query: {
        phone: "",
        name: "",
        departmentId: null,
        provinceCode: "",
        cityCode: ""
      },
      data: {
        isLoading: false,
        provinceCodes: [],
        cityCodes: [],
        list: [],
        pageNum: 1,
        pageSizeArray: PAGE_SIZE_ARRAY,
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      edited: {
        editedDialogFlag: false,
        name: "",
        majorDepartName: "",
        provinceName: "",
        cityName: "",
        departmentId: null,
        isApprv: "",
        rejectReason: "",
        userId: ""
      },
      view: {
        userId: "",
        viewDialogFlag: false
      },
      addDepartment: {
        addDialogFlag: false
      },
      selectedDepartTp: null
    };
  },
  created() {
    /*this.form.codesTree = this.codesTree;
    this.form.eimsCodes = this.eimsCodes;*/
  },
  mounted() {
    this.getDepartments();
    this.queryData();
  },
  filters: {
    getProvinceName(value, vue) {
      return vue.getProvinceNameMethod(value);
    },
    getCityName(value, vue) {
      return vue.getCityNameMethod(value);
    }
  },
  methods: {
    getProvinceNameMethod(value) {
      for (let arr in this.eimsCodes) {
        if (this.eimsCodes[arr].cd == value) {
          return this.eimsCodes[arr].cdDesc;
        }
      }
      return "";
    },
    getCityNameMethod(value) {
      for (let arr in this.eimsCodes) {
        if (this.eimsCodes[arr].cd == value) {
          return this.eimsCodes[arr].cdDesc;
        }
      }
      return "";
    },
    handleQueryClick() {
      this.query.phone = this.form.phone;
      this.query.name = this.form.name;
      this.query.departmentId = this.form.departmentId;
      this.query.provinceCode = this.form.provinceCode;
      this.query.cityCode = this.form.cityCode;
      this.handlePageChange(1);
    },

    handlePageChange(val) {
      this.data.currentPage = val;
      this.data.pageNum = val;
      this.queryData();
    },
    handleSizeChange(val) {
      this.data.pageSize = val;
      this.queryData();
    },
    queryData() {
      let _this = this;
      _this.data.isLoading = true;
      let token = cookie.getCookie("token");
      http
        .post(window.config.api.baseUrl + "/eims-api/user/approve/list", {
          token: token,
          data: {
            userId: this.query.phone,
            name: this.query.name,
            departmentId: this.query.departmentId,
            provinceCode: this.query.provinceCode,
            cityCode: this.query.cityCode,
            pageNum: this.data.pageNum,
            pageSize: this.data.pageSize
          }
        })
        .then(response => {
          this.data.list = response.data.data.eimsUserList;
          this.data.total = response.data.data.total;
        })
        .finally(() => {
          _this.data.isLoading = false;
        });
    },
    getDepartments() {
      let token = cookie.getCookie("token");
      http
        .post(
          window.config.api.baseUrl + "/eims-api/department/findCurrentAndSub",
          {
            token: token,
            data: {
              pageSize: -1
            }
          }
        )
        .then(response => {
          this.form.departments = response.data.data.departments;
        });
    },
    handleDeptChange(value) {
      this.$refs.deptCascader.dropDownVisible = false;
      this.form.departmentId = value[value.length - 1];
    },
    handleApproveDeptChange(value) {
      if (this.$refs.editDeptCascader.getCheckedNodes()[0] !== undefined) {
        console.log(this.$refs.editDeptCascader.getCheckedNodes()[0].data);
        this.selectedDepartTp = this.$refs.editDeptCascader.getCheckedNodes()[0].data.tp;
      } else {
        this.selectedDepartTp = null;
      }
      this.$refs.editDeptCascader.dropDownVisible = false;
      this.edited.departmentId = value[value.length - 1];
      console.log(this.edited.departmentId);
    },
    handleCodeChange(value) {
      if (value && value.length > 0) {
        this.$refs.codeCascader.dropDownVisible = false;
        this.form.provinceCode = value[0];
        this.form.cityCode = value.length > 1 ? value[1] : "";
      } else {
        this.form.provinceCode = "";
        this.form.cityCode = "";
      }
      this.handleQueryClick();
    },
    //查看被审核人员信息
    handleViewClick(row) {
      let userId = row.userId;
      this.view.userId = userId;
      this.view.viewDialogFlag = true;
    },
    toEditedDialog(item) {
      this.edited.userId = item.userId;
      this.edited.name = item.name;
      this.edited.majorDepartName = item.majorDepartName;
      this.edited.provinceName = this.getProvinceNameMethod(item.provinceCode);
      this.edited.cityName = this.getCityNameMethod(item.cityCode);
      this.edited.editedDialogFlag = true;
    },
    handleCommitDialog() {
      let _this = this;
      if (!_this.edited.isApprv) {
        Message.error({ message: "请选择操作同意或拒绝！", showClose: true });
        return;
      }
      if (_this.edited.isApprv == "0" && !_this.edited.rejectReason.trim()) {
        Message.warning({ message: "拒绝原因不能为空！", showClose: true });
        return;
      }
      if (_this.edited.isApprv == "1" && !_this.edited.departmentId) {
        Message.error({ message: "关联机构不能为空！", showClose: true });
        return;
      }
      if (_this.edited.isApprv == "1" && _this.selectedDepartTp < 5) {
        Message.error({
          message: "关联机构只能选择医院和科室！",
          showClose: true
        });
        return;
      }
      let token = cookie.getCookie("token");
      http
        .post(window.config.api.baseUrl + "/eims-api/user/approve", {
          token: token,
          data: {
            userId: _this.edited.userId,
            isApprv: _this.edited.isApprv,
            departmentId: _this.edited.departmentId,
            rejectReason: _this.edited.rejectReason
          }
        })
        .then(response => {
          if (response.data.code == "00000") {
            Message.success({ message: "审核成功", showClose: true });
            _this.handleCloseDialog();
            _this.queryData();
          }
        });
    },
    resetConditions() {
      Object.assign(this.$data.form, this.$options.data().form);
      this.query.phone = this.form.phone;
      this.query.name = this.form.name;
      this.query.departmentId = this.form.departmentId;
      this.query.provinceCode = this.form.provinceCode;
      this.query.cityCode = this.form.cityCode;
      this.handlePageChange(1);
    },
    handleCloseDialog() {
      this.edited.editedDialogFlag = false;
      this.edited.name = "";
      this.edited.majorDepartName = "";
      this.edited.departmentId = null;
      this.edited.userId = "";
      this.edited.isApprv = "";
      this.edited.rejectReason = "";
      this.edited.provinceName = "";
      this.edited.cityName = "";
      this.view.viewDialogFlag = false;
      this.view.userId = "";
      this.selectedDepartTp = null;
    },
    handleAddDept() {
      this.addDepartment.addDialogFlag = true;
    },
    handleCloseAddDeptDialog() {
      this.getDepartments();
      this.addDepartment.addDialogFlag = false;
    }
  },
  computed: {
    ...mapState({
      eimsCodes: state => state.codeDictModule.eimsCodes,
      codesTree: state => state.codeDictModule.codesTree
    })
  }
};
</script>

<style scoped>
.component-container {
  border-radius: 10px;
}

.table-card {
  margin-top: 10px;
}

.el-form {
}

.header-card {
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
}

.member-approve-table {
  padding-top: 20px;
}

.dialog-content-span {
  float: left;
}

/deep/ .el-dialog__footer {
  text-align: center;
}

.member-form-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

/deep/ .el-form-item--small.el-form-item {
  margin-bottom: 0;
}

/deep/ .el-form-item--small.el-form-item > * {
  margin-top: 5px;
}

/deep/
  .member-approve-table
  .el-table--striped
  .el-table__body
  tr.el-table__row--striped
  td {
  background-color: #f3fdff !important;
}

.member-head-opt-btn {
  margin: 0 10px;
}
/deep/ .view-dialog .el-dialog__header {
  padding: unset;
}
/deep/ .add-dept-dialog .el-dialog__header {
  padding: unset;
}
/deep/ .add-dept-dialog .el-dialog__body {
  padding: unset;
}
.required-label {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/MemberApprove.vue